import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import ScrollToTop from "./scrollToTop"

const root = ReactDOM.createRoot(document.getElementById('harielroot'));

root.render(
  <BrowserRouter>
    
      <ScrollToTop />
      <App />
  
  </BrowserRouter>
);

